export default __webpack_public_path__ + "static/media/netlify.1d9cb9ac.svg";